import {
    SET_HOME_BOOKMARK,
    SET_SELECTED_BOOKMARK,

    TOGGLE_HOME_BOOKMARK_REQUEST,
    TOGGLE_HOME_BOOKMARK_SUCCESS,
    TOGGLE_HOME_BOOKMARK_FAILURE,
    FETCH_HOME_BOOKMARK_REQUEST,
    FETCH_HOME_BOOKMARK_SUCCESS,
    FETCH_HOME_BOOKMARK_FAILURE
} from './Types';

import { setMapProperties, setMapPosition, setFitBounds } from '../map/Actions';
import { MAIN_MAP } from '../map/Constants';
import axios from 'axios';

import { fetchAllAsync, fetchAsync, createAsync, deleteAsync, renameAsync } from '../common/Actions';
import { Bookmark } from './bookmarkTypes';
let fetchBookmarksSource: any, fetchBookmarkSource: any, createBookmarkSource: any, deleteBookmarkSource: any, renameBookmarkSource: any;

const toggleHomeBookmark = () => ({ type: TOGGLE_HOME_BOOKMARK_REQUEST });
const toggleHomeBookmarkSuccess = (bookmark:Bookmark) => ({ type: TOGGLE_HOME_BOOKMARK_SUCCESS, bookmark });
const toggleHomeBookmarkError = (error:string) => ({ type: TOGGLE_HOME_BOOKMARK_FAILURE, error });

export const setHomeBookmark = (id:(number|string)) => ({ type: SET_HOME_BOOKMARK, id });
export const setSelectedBookmark = (bookmark:Bookmark) => ({ type: SET_SELECTED_BOOKMARK, value: bookmark });

export const activateBookmark = (bookmark:Bookmark) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        if (bookmark && bookmark.view) {
            const properties:{
                bearing?:any;
                pitch?:any;
                fitBounds?:any;
            } = {
                // fitBounds: [ ...bookmark.view.bounds ], // Legacy - dedicated fit bounds now
                // fitBoundsOptions: { maxZoom: 22 } // Legacy - dedicated fit bounds now
            };
            if (bookmark.view.bearing) {
                properties.bearing = bookmark.view.bearing || 0;
            }

            if (bookmark.view.pitch) {
                properties.pitch = bookmark.view.pitch || 0;
            }

            dispatch(setFitBounds([...bookmark.view.bounds as number[]], { padding: 0 }, MAIN_MAP));
            dispatch(setMapProperties(properties, MAIN_MAP));
            dispatch(setMapPosition(properties.fitBounds, MAIN_MAP));
        }
    };
};

export const fetchHomeBookmarkAsync = () => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch({
            type: FETCH_HOME_BOOKMARK_REQUEST
        });
        return axios.get('/api/bookmarks/home_bookmark')
            .then((res) => {
                dispatch({
                    type: FETCH_HOME_BOOKMARK_SUCCESS,
                    value: res.data.id
                });
            })
            .catch((err) => {
                dispatch({
                    type: FETCH_HOME_BOOKMARK_FAILURE,
                    error: err.message
                });
            });
    };
};

export const toggleHomeBookmarkAsync = (id:(number|string)) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(toggleHomeBookmark());
        return axios.patch(`/api/bookmarks/${id}/home`, {
        }).then(response => {
            dispatch(toggleHomeBookmarkSuccess(response.data.bookmark));
            dispatch(fetchHomeBookmarkAsync());
        }).catch(error => {
            dispatch(toggleHomeBookmarkError(error.response));
        });
    };
};


export const fetchBookmarksAsync = () => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(fetchAllAsync('bookmarks', 'bookmarks', fetchBookmarksSource));
    };
};

export const fetchBookmarkAsync = (id:(number|string)) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(fetchAsync('bookmarks', 'bookmark', id, fetchBookmarkSource));
    };
};

export const createBookmarkAsync = (params:any) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(createAsync('bookmarks', 'bookmark', params, createBookmarkSource));
    };
};

export const deleteBookmarkAsync = (id:(number|string)) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(deleteAsync('bookmarks', 'bookmark', id, deleteBookmarkSource));
    };
};

export const renameBookmarkAsync = (id:(number|string), name:string) => {
    return (dispatch:(dispatch: any) => Promise<void>) => {
        dispatch(renameAsync('bookmarks', 'bookmark', id, name, renameBookmarkSource));
    };
};